export enum BuildingType {
    SingleFamilyHouse = 'ONE_FAMILY_HOUSE',
    MultiFamilyHouse = 'MULTI_FAMILY_HOUSE'
}
